<template>
  <div class="contaier">
    <head-page />

    <div class="banner-top">
      <div class="btn-box">
        <div class="btn-l">
          <img class="img" alt="" :src="bannerParam.logoImg.logo" />
          <div class="cell-value">{{ bannerParam.logoImg.title }}</div>
        </div>
        <!-- <div class="btn-r" @click="goNewPage2('/carDetails', 2)">
          <div class="cell" :key="item.id" v-for="item in bannerParam.paramList">
            <div class="cell-name">{{ item.value }}</div>
            <div class="cell-value">{{ item.name }}</div>
          </div>
        </div> -->
      </div>
      <div class="img-box">
        <picture v-if="carDetails.banner.img">
          <source
            v-if="carDetails.banner.img_mobile"
            media="(max-width: 760px)"
            :srcset="carDetails.banner.img_mobile"
          />
          <img class="img" :src="carDetails.banner.img" @error="onImgError" />
        </picture>
      </div>
    </div>

    <!-- ---------------------- 不同色车 -------------------- -->
    <div
      class="colors-box"
      :class="[carType == 'V27' ? 'w-fu' : 'w-80']"
      @touchstart="onColorTouchStart"
      @touchend="onColorTouchEnd"
      @mousedown="onColorMouseDown"
      @mouseup="onColorMouseUp"
      @mouseleave="onColorMouseLeave"
      @dragstart.prevent
    >
      <div
        :key="item.id"
        class="color-item"
        :class="{ 'current-show': currentColor === index }"
        v-for="(item, index) in carDetails.switchColors"
      >
        <!-- {{ item.img_mobile }} -->
        <!-- <img class="img" alt="" :src="item.img" @error="onImgError" /> -->
        <picture class="picture">
          <source
            class="source"
            v-if="item.img_mobile"
            alt=""
            media="(max-width: 760px)"
            :srcset="item.img_mobile"
          />
          <img class="img" alt="" :src="item.img" draggable="false" @error="onImgError" />
        </picture>
      </div>

      <div class="indicator-box">
        <div
          :key="item.id"
          class="indicator-item"
          @click="colorItemClick(index)"
          v-for="(item, index) in carDetails.switchColors"
        >
          <div>
            <div :class="['color-text', currentColor === index ? 'color-text_ac' : '']">
              {{ item.colorText }}
            </div>
            <div
              :style="{ background: `linear-gradient(45deg, ${item.colorBg})` }"
              :class="['indicator', currentColor === index ? 'indicator-ac' : '']"
            ></div>
          </div>
        </div>
      </div>
      <!-- <div v-if="carType == 'V23'" class="panoramic-360" @click="go360Page">
        <img class="img" alt="" srcset="@/assets/img/360Logo.webp" />
        <div class="text">Panoramic Exploration</div>
      </div> -->
    </div>

    <!-- ---------------------- car-column3内籠顔色 -------------------- -->
    <div :class="['car-column', isMobile ? 'car-column_mobile' : '']">
      <div class="title">{{ carDetails.carColumn3.title }}</div>
      <swiper ref="column3Ref" class="swiper-column" :options="columnSwiperOptions3">
        <swiper-slide :key="item.id" v-for="(item, index) in carDetails.carColumn3.list">
          <div class="swiper-item">
            <div class="swiper-item_inside">
              <img class="img" alt="" :src="item.img" @error="onImgError" />
              <div class="more-box" @click.stop="handleMouseEnter(item, index)" 
                v-if="item.introduce">
                <i
                  :class="[
                    'icon',
                    'el-icon-arrow-down',
                    index == columnIndex ? 'icon-ac' : '',
                  ]"
                ></i>
                <div class="more">探索更多</div>
              </div>
              <div
                class="content-box"
                :class="{ 'content-box_ac': index == columnIndex }"
              >
                <div class="swiper-title">{{ item.title }}</div>
                <div class="swiper-introduce">{{ item.introduce }}</div>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <CenterIndicator
        v-if="isMobile && carDetails.carColumn3.list.length > 0"
        class="center-indicator"
        :currentIndex="currColumn3"
        :totalCount="carDetails.carColumn3.list.length"
      ></CenterIndicator>
    </div>

    <!-- ------------------------------ car-column2外 --------------------------------- -->
    <div :class="['car-column', isMobile ? 'car-column_mobile' : '']">
      <div class="title">{{ carDetails.carColumn2.title }}</div>
      <swiper ref="column2Ref" class="swiper-column" :options="columnSwiperOptions2">
        <swiper-slide :key="item.id" v-for="(item, index) in carDetails.carColumn2.list">
          <div class="swiper-item">
            <div class="swiper-item_inside">
              <img class="img" alt="" :src="item.img" @error="onImgError" />
              <div
                class="more-box"
                v-if="item.introduce"
                @click.stop="handleMouse2Enter(item, index)"
              >
                <i
                  :class="[
                    'icon',
                    'el-icon-arrow-down',
                    index == column2Index ? 'icon-ac' : '',
                  ]"
                ></i>
                <div class="more">探索更多</div>
              </div>
              <div
                class="content-box"
                :class="{ 'content-box_ac': index == column2Index }"
              >
                <div class="swiper-title">{{ item.title }}</div>
                <div class="swiper-introduce">{{ item.introduce }}</div>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <CenterIndicator
        v-if="isMobile"
        class="center-indicator"
        :currentIndex="currColumn2"
        :totalCount="carDetails.carColumn2.list.length"
      ></CenterIndicator>
    </div>
    <!-- ------------------------------ car-column1内 --------------------------------- -->
    <!-- @mouseleave="columnIndex = -1" @mouseenter="handleMouseEnter(item, index)" -->
    <div :class="['car-column', isMobile ? 'car-column_mobile' : '']">
      <div class="title">{{ carDetails.carColumn.title }}</div>
      <swiper ref="column1Ref" class="swiper-column" :options="columnSwiperOptions1">
        <swiper-slide :key="item.id" v-for="(item, index) in carDetails.carColumn.list">
          <div class="swiper-item">
            <div class="swiper-item_inside">
              <img class="img" alt="" :src="item.img" @error="onImgError" />
              <div class="more-box" @click.stop="handleMouseEnter(item, index)" v-if="item.introduce">
                <i
                  :class="[
                    'icon',
                    'el-icon-arrow-down',
                    index == columnIndex ? 'icon-ac' : '',
                  ]"
                ></i>
                <div class="more">探索更多</div>
              </div>
              <div
                class="content-box"
                :class="{ 'content-box_ac': index == columnIndex }"
              >
                <div class="swiper-title">{{ item.title }}</div>
                <div class="swiper-introduce">{{ item.introduce }}</div>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <CenterIndicator
        v-if="isMobile"
        class="center-indicator"
        :currentIndex="currColumn1"
        :totalCount="carDetails.carColumn.list.length"
      ></CenterIndicator>
    </div>
    <!-- ---------------------- gallery -------------------- -->
    <div :class="['swiper-box', isMobile ? 'swiper-box_mobile' : '']">
      <swiper
        ref="swiperMain"
        class="main-swiper"
        @ready="onMainSwiper"
        :options="mainSwiperOptions"
      >
        <swiper-slide
          :key="item.id"
          class="swiper-slide"
          v-for="item in carDetails.gallery"
        >
          <picture>
            <source
              class="img"
              alt=""
              media="(max-width: 760px)"
              :srcset="item.img_mobile"
            />
            <img class="img" alt="" :srcset="item.img" @error="onImgError" />
          </picture>
        </swiper-slide>
      </swiper>
      <CenterIndicator
        v-if="isMobile"
        class="center-indicator"
        :currentIndex="activeIndex"
        :totalCount="carDetails.gallery.length"
      ></CenterIndicator>
      <div v-else class="indicator-box">
        <div
          :key="item"
          @click="indicatorClick(index)"
          v-for="(item, index) in carDetails.gallery.length"
          :class="['indicator-item', activeIndex === index ? 'indicator-item_ac' : '']"
        ></div>
      </div>
    </div>
    <!-- -------------------------------  ------------------------------------- -->
    <!-- ----------------- last-page ------------------------ -->
    <div class="last-pages" :style="{ marginTop: isMobile ? '110px' : '50px' }" v-if="carType === 'V27' && carDetails.latePage && carDetails.latePage.length">
      <!-- 大图轮播 -->
      <swiper
        ref="lastMainSwiper"
        class="last-main-swiper"
        :options="lastMainSwiperOptions"
        @slideChangeTransitionEnd="onLastMainSlideChange"
      >
        <swiper-slide :key="item.id" v-for="item in carDetails.latePage">
          <picture>
            <source
              alt=""
              media="(max-width: 760px)"
              :srcset="item.img_mobile"
            />
            <img class="img" alt="" :srcset="item.img" @error="onImgError" />
          </picture>
        </swiper-slide>
      </swiper>
      <!-- 底部缩略图 + 文字 -->
      <div class="last-page_column">
        <div class="swiper-in" @mouseleave="mouseleavelast" @mouseenter="mouseEnterlast">
          <div class="text-box_last">
            <div
              class="title hq-title1"
              :style="{ color: (carDetails.latePage[lastIndex].fontColor || '#fff') }"
            >
              {{ carDetails.latePage[lastIndex].title }}
            </div>
            <div
              class="introduce"
              :style="{
                color: (carDetails.latePage[lastIndex].fontColor || '#fff'),
                opacity: 0.7,
              }"
            >
              {{ carDetails.latePage[lastIndex].introduce }}
            </div>
          </div>
          <div class="fsdfsdf">
            <swiper
              ref="lastPageSwiper"
              class="swiper-column"
              @ready="onlastMainSwiper"
              :options="lastPageSwiperOptions"
            >
              <swiper-slide :key="item.id" v-for="(item, index2) in carDetails.latePage">
                <div class="swiper-item" @click="lastSwiperItemClick(index2)">
                  <div
                    class="swiper-item_inside"
                    :class="{ 'swiper-item_inside--ac': lastIndex === index2 }"
                  >
                    <img class="img" alt="" :src="item.img" @error="onImgError" />
                    <div class="content-box">
                      <div class="swiper-title">{{ item.title }}</div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </div>

    <!-- ------------------------- parameters ----------------------- -->
    <!-- carDetail.parameters -->
    <div class="parameters-box">
      <div class="max-box">
        <!-- <div class="parameters-title">車輛參數</div> -->
        <!-- <el-table
          :data="parList"
          :span-method="paramSpanMethod"
          :row-class-name="paramRowClassName"
        >
          <el-table-column min-width="160" prop="prop_name" label="規格">
            <template slot-scope="scope">
              <span :class="{ 'group-title-cell': scope.row.isGroup }">{{ scope.row.prop_name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            min-width="100"
            :key="item.styleID"
            :prop="item.param"
            v-for="item in vesList"
            :label="item.car_model"
          >
          </el-table-column>
        </el-table> -->
        <div class="parameters-title">車輛尺寸</div>
        <div class="parameters-img">
          <el-image
            v-if="carDetails.parametersImg1"
            class="img"
            :src="carDetails.parametersImg1"
            :preview-src-list="[carDetails.parametersImg1]"
            fit="contain"
          >
            <div slot="placeholder" class="img-placeholder"></div>
            <div slot="error" class="img-placeholder img-placeholder_error">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <div class="sub-title">{{ carDetails.modelName == 'V27' ? '（後備胎）' : '' }}</div>

          <el-image 
            v-if="carDetails.parametersImg2"
            class="img"
            :src="carDetails.parametersImg2"
            :preview-src-list="[carDetails.parametersImg2]"
            fit="contain"
          >
            <div slot="placeholder" class="img-placeholder"></div>
            <div slot="error" class="img-placeholder img-placeholder_error">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <div class="sub-title" v-if="carDetails.parametersImg2">{{ carDetails.modelName == 'V27' ? '（書包）' : '' }}</div>

        </div>
        <div class="download-btn-box">
          <div class="btn" @click="goContactPage">下載{{ carType }}產品介紹書</div>
        </div>
        <div class="prop_hint">
          - 本網頁中所有照片僅供參考。車身顏色，車廂顏色，功能和規格可能會與本網頁的相片稍有不同。<br/>
          - 規格及配備細節可能因應當地條件及需求而變更，詳情請咨詢銷售顧問。<br/>
          - 所有額外選配需另計費用（含首次登記稅），詳情請參閱價格表。<br/>
          - Star Auto Holding Limited 保留更改產品規格及設備之最終權利，恕不另行通知。  <br/>
          <br/>
          {{ carDetails.prop_hint }}
        </div>
      </div>
    </div>
    <footer-page></footer-page>
  </div>
</template>

<script>
import { throttle } from "lodash";
import {
  columnOptions,
  // carDetailsV23,
  // carDetailsV27,
  carDetails,
  carBannerParam23,
  carBannerParam27,
} from "@/assets/js/static2";
import {
  imgBase,
  //   modelList,
  //   detailNvgList,
} from "@/assets/js/static";
// import { langMixins } from '@/mixins/langMixins'
import {
  modelDetailsApi,
  //   modelPropParameterApi,
  modelParameterApi,
  modelPropParameterApi,
} from "@/Api/requestApi";
import HeadPage from "@/components/HeadPage.vue";
import CenterIndicator from "@/components/CenterIndicator.vue";
import FooterPage from "@/components/FooterPage.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
// import 'swiper/css/swiper.css'
export default {
  name: "CarDetails",
  // mixins: [langMixins],
  components: {
    HeadPage,
    FooterPage,
    CenterIndicator,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      columnIndex: -1,
      column2Index: -1,
      currColumn1: 0,
      currColumn2: 0,
      currColumn3: 0,
      currentColor: 0,
      // carDetail: {
      //   banner: {},
      //   carColumn: [],
      //   switch: [],
      //   pages: [{ title: "", introduce: "", img: "" }],
      //   switchColors: [],
      //   parameters: [],
      // },
      ParameterList: [],
      carDetails: carDetails,
      activeIndex: 0,
      mainSwiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        // loop: true,
        speed: 1200,
        // grabCursor: true,
        on: {
          transitionStart: () => {
            // console.log(" this. ", this.$refs.swiperMain.$swiper.activeIndex);
            this.activeIndex = this.$refs.swiperMain.$swiper.activeIndex;
          },
        },
      },
      columnSwiperOptions1: {
        ...columnOptions,
        on: {
          slideChange: () => {
            this.currColumn1 = this.$refs.column1Ref.$swiper.activeIndex;
          },
        },
      },
      columnSwiperOptions2: {
        ...columnOptions,
        on: {
          slideChange: () => {
            this.currColumn2 = this.$refs.column2Ref.$swiper.activeIndex;
          },
        },
      },
      columnSwiperOptions3: {
        ...columnOptions,
        on: {
          slideChange: () => {
            this.currColumn3 = this.$refs.column3Ref.$swiper.activeIndex;
          },
        },
      },
      lastIndex: 0,
      lastMainSwiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 600,
        grabCursor: true,
      },
      lastPageSwiperOptions: {
        autoplay: false,
        slidesPerView: 4.3,
        spaceBetween: 12,
        breakpoints: {
          0: { slidesPerView: 3.2, spaceBetween: 8 },
          768: { slidesPerView: 3.8 },
          992: { slidesPerView: 4.3 },
        },
      },
      mainSwiper: null,
      carId: null,
      scrollHandler: null,
      lastsSwiper: null,
      bannerParam: {
        paramList: [],
        logoImg: { title: "", logo: "" },
      },
      carType: "",
      carPdfUrl: "",
      vesList: [],
      parList: [],
      isMobile: false,
      // 颜色轮播滑动手势
      colorTouchStartX: 0,
      colorTouchStartY: 0,
      colorMouseStartX: 0,
      colorMouseDown: false,
    };
  },
  mounted() {
    // let flag=false
    // 路由参数 slug 即为 modelName 小写（如 /models/v23 → modelName "V23"）
    let id_ = this.$route?.params?.slug || this.$route?.query?.id;
    this.carId = id_;
    // console.log("id_ :>> -------", id_);
    this.$nextTick(() => {
      this.scrollHandler = throttle(this.handleResize, 200);
      window.addEventListener("resize", this.scrollHandler);
      this.handleResize();
    });
    this.initCarData(id_);
    // document.body.scrollTop = 0
    // document.documentElement.scrollTop = 0
    // console.log('mounted ')
    this.$nextTick(() => {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    });
  },
  methods: {
    // 图片加载失败时隐藏 img，避免浏览器默认破图图标；占位背景由容器保留
    onImgError(e) {
      e.target.style.visibility = "hidden";
    },
    goContactPage() {
      const query = { carModel: this.carId };
      // 透传产品介绍书 PDF 地址，联系页提交成功后可直接使用，无需重复请求
      // if (this.carPdfUrl) {
      //   query.pdf = this.carPdfUrl;
      // }
      this.$router.push({ path: "/contact-us", query });
    },
    async initCarData(id_) {
      // 先获取车型详情，拿到数字 id 后再请求参数接口
      await this.modelDetailsFn(id_);
      const numericId = this.carId;
      await this.getModelParameterTitleFn(numericId);
      this.getModelParameterFn(numericId);
    },
    async modelDetailsFn(id_) {
      // id_
      const {
        data: { code, data },
        // } = await modelDetailsApi({ id: 4 });
      } = await modelDetailsApi(isNaN(Number(id_)) ? { modelName: id_ } : { id: id_ });
      console.log("data :>> ", data);
      if (code == 200) {
        let {
          id,
          model_car,
          exterior,
          imgKV,
          imgKV_mobile,
          video,
          prop_hint,
          modelName,
          highlight,
          gallery,
          model_style = [
            {
              styleID: 1,
              car_model: "",
              car_modelEn: "",
            },
          ],
          other = [],
        } = data;

        // 保存 API 返回的数字 id，供后续参数 API 使用
        this.carId = id;
        // let model_style_ = JSON.stringify(model_style)
        if (modelName === "V27") {
          this.carType = "V27";
          this.bannerParam = carBannerParam27;
          // this.carDetail = carDetailsV27;
        } else {
          this.carType = "V23";
          this.bannerParam = carBannerParam23;
          // this.carDetail = carDetailsV23;
        }
        let other_ = JSON.parse(other);
        let latePage = [];

        for (let i = 0; i < other_.length; i++) {
          const { title, text, highImg, fontColor } = other_[i];
          latePage.push({
            id: i + 1,
            title,
            introduce: text,
            img: `${imgBase}${highImg}`,
            fontColor: fontColor || '#fff'
          });
        }

        let { car_model = "", car_modelEn = "" } = JSON.parse(model_style)[0];
        // console.log('object :>> ', model_style_)
        // return
        let exterior_ = [];
        for (let i = 0; i < exterior.length; i++) {
          const {
            front_45_side,
            front_90_side,
            front_color_name,
            front_color_val,
          } = exterior[i];

          exterior_.push({
            id: i + 1,
            colorBg: front_color_val,
            colorText: front_color_name,
            img: `${imgBase}${front_90_side}`,
            img_mobile: front_45_side ? `${imgBase}${front_45_side}` : "",
          });
        }

        let highlight_ = JSON.parse(highlight);
        let gallery_ = JSON.parse(gallery);
        let model_car_ = JSON.parse(model_car);
        // 产品介绍书 PDF 地址（model_car[0].pdfUrl），供跳转联系页时透传
        this.carPdfUrl = (model_car_[0] && model_car_[0].pdfUrl) || "";
        let _gallery = [];

        for (let i = 0; i < gallery_.length; i++) {
          _gallery.push({
            id: i + 1,
            img: `${imgBase}${gallery_[i]}`,
          });
        }

        console.log("highlight_ :>> ", highlight_);
        // console.log('object :>> ', JSON.parse(highlight))
        let interiorArr_ = [];
        let exteriorDetailsArr_ = [];
        let interiorColorArr_ = [];

        let {
          interior,
          interiorArr = [],
          eteriorDetails,
          exteriorDetailsArr = [],
          interiorColor,
          interiorColorArr = [],
        } = highlight_;
        // console.log("interiorArr :>>---------------- ", interiorArr);

        for (let i = 0; i < interiorColorArr.length; i++) {
          const { title, text, highImg } = interiorColorArr[i];
          interiorColorArr_.push({
            id: i + 1,
            title,
            introduce: text,
            img: `${imgBase}${highImg}`,
          });
        }

        for (let i = 0; i < interiorArr.length; i++) {
          const { title, text, highImg } = interiorArr[i];
          interiorArr_.push({
            id: i + 1,
            title,
            introduce: text,
            img: `${imgBase}${highImg}`,
          });
        }

        // console.log("interiorArr_ :>> ", interiorArr_);

        for (let i = 0; i < exteriorDetailsArr.length; i++) {
          const { text, title, titleEn, highImg } = exteriorDetailsArr[i];
          exteriorDetailsArr_.push({
            id: i + 1,
            title,
            introduce: text,
            img: `${imgBase}${highImg}`,
            img_mobile: `${imgBase}${titleEn}`,
          });
        }

        this.carDetails = {
          id,
          parametersImg1: `${model_car_[0].dimensionImg1 == '' ? '' : `${imgBase}${model_car_[0].dimensionImg1}`}`, 
          parametersImg2: `${model_car_[0].dimensionImg2 == '' ? '' : `${imgBase}${model_car_[0].dimensionImg2}`}`,
          latePage,
          modelName,
          gallery: _gallery,
          video,
          prop_hint,
          carColumn: {
            title: interior,
            list: interiorArr_,
          },
          carColumn3: {
            title: interiorColor,
            list: interiorColorArr_,
          },
          carColumn2: {
            title: eteriorDetails,
            list: exteriorDetailsArr_,
          },
          switchColors: exterior_,
          banner: {
            title: car_model,
            img: `${imgBase}${imgKV}`,
            introduce: car_modelEn,
            img_mobile: `${imgBase}${imgKV_mobile}`,
          },
        };
        console.log(" this.carDetails  :>>-- ", this.carDetails);
      }
    },
    async getModelParameterTitleFn (id) {
       const {
        data: { code, data },
      } = await modelParameterApi(isNaN(Number(id)) ? { modelName: id } : { id });
      if (code == 200) {
        console.log('modelParameterApi data:', JSON.stringify(data))
        // 兼容数组或对象格式
        if (Array.isArray(data)) {
          this.ParameterList = data
        } else if (data && typeof data === 'object') {
          this.ParameterList = Object.entries(data).map(([k, v]) => ({
            propt_id: k,
            prop_name: typeof v === 'string' ? v : (v.prop_name || v.propt_name || v.name || v.title || ''),
          }))
        }
      }
    },
    async getModelParameterFn(id) {
      const {
        data: { code, data, modelList },
      } = await modelPropParameterApi(isNaN(Number(id)) ? { modelName: id } : { id });
      if (code == 200) {
        let _vesList = [];
        let mn_ = JSON.parse(modelList[0].model_style);
        let firstKey = Object.keys(data);

        // 构建车型列头
        for (let i = 0; i < mn_.length; i++) {
          const { styleID, car_model } = mn_[i];
          _vesList.push({
            styleID,
            car_model,
            param: `car${i + 1}`,
            prop_name: "prop_name",
          });
        }

        // 构建标题映射: propt_id -> title
        const titleMap = {};
        if (this.ParameterList && this.ParameterList.length) {
          const idFields = ['propt_id', 'id', 'typeId', 'type_id', 'ptId', 'pt_id'];
          const nameFields = ['prop_name', 'propt_name', 'prop_type_name', 'typeName', 'type_name', 'ptName', 'pt_name', 'title', 'name'];
          this.ParameterList.forEach((item) => {
            if (!item || typeof item !== 'object') return;
            let pid = '', title = '';
            for (const f of idFields) { if (item[f] !== undefined && item[f] !== '') { pid = String(item[f]); break; } }
            for (const f of nameFields) { if (item[f]) { title = String(item[f]); break; } }
            if (pid && title) titleMap[pid] = title;
          });
        }
        console.log('titleMap:', JSON.stringify(titleMap));

        // 按 propt_id 分组，保持顺序
        const groupOrder = [];
        const groupMap = {};

        for (let i = 0; i < firstKey.length; i++) {
          let _list = data[i + 1];
          if (!_list) continue;
          for (let j = 0; j < _list.length; j++) {
            const { prop_name, prop_valCtt, propt_id } = _list[j];
            const pid = String(propt_id || '');

            if (!groupMap[pid]) {
              groupMap[pid] = {
                propt_id: pid,
                title: titleMap[pid] || pid,
                rows: [],
              };
              groupOrder.push(pid);
            }

            if (i === 0) {
              groupMap[pid].rows.push({
                prop_name,
                car1: prop_valCtt,
              });
            } else {
              const rows = groupMap[pid].rows;
              let rowIndex = 0;
              for (let k = 0; k < j; k++) {
                if (String(_list[k].propt_id || '') === pid) {
                  rowIndex++;
                }
              }
              if (rows[rowIndex]) {
                rows[rowIndex][`car${i + 1}`] = prop_valCtt;
              }
            }
          }
        }

        // 生成扁平列表：分组标题行 + 参数行交替
        let flatList = [];
        groupOrder.forEach((pid) => {
          const group = groupMap[pid];
          // 插入分组标题行
          flatList.push({
            isGroup: true,
            prop_name: group.title,
          });
          // 插入该组的参数行
          group.rows.forEach((row) => {
            flatList.push(row);
          });
        });

        this.parList = flatList;
        this.vesList = _vesList;
      }
    },
    // 分组标题行合并所有列；相同参数值合并车型列（含●的不合并）
    paramSpanMethod({ row, columnIndex }) {
      if (row.isGroup) {
        if (columnIndex === 0) {
          return [1, this.vesList.length + 1];
        }
        return [0, 0];
      }

      // 規格列不合并
      if (columnIndex === 0) return [1, 1];

      const carIndex = columnIndex - 1; // 0-based 车型列索引
      const colCount = this.vesList.length;
      const curVal = row[`car${carIndex + 1}`];

      // 含 ● 的值不合并
      if (String(curVal).includes('●')) return [1, 1];

      // 如果和前一列值相同，说明已被前一列合并覆盖
      if (carIndex > 0) {
        const prevVal = row[`car${carIndex}`];
        if (prevVal === curVal && !String(prevVal).includes('●')) {
          return [0, 0];
        }
      }

      // 向后检查连续相同值，计算 colspan
      let colspan = 1;
      for (let next = carIndex + 1; next < colCount; next++) {
        const nextVal = row[`car${next + 1}`];
        if (nextVal === curVal && !String(nextVal).includes('●')) {
          colspan++;
        } else {
          break;
        }
      }

      return [1, colspan];
    },
    // 分组标题行样式
    paramRowClassName({ row }) {
      return row.isGroup ? 'group-title-row' : '';
    },
    handleResize() {
      let ww_ = window.innerWidth;
      if (ww_ <= 768) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
      console.log("this.isMobile  :>> ", this.isMobile);
    },
    onMainSwiper(e) {
      this.mainSwiper = e;
    },
    onlastMainSwiper(e) {
      this.lastsSwiper = e;
    },
    // 点击缩略图手动切换主轮播
    indicatorClick(i) {
      if (this.activeIndex === i) return;
      console.log("i :>>  ind", i);
      this.activeIndex = i;
      if (this.mainSwiper) {
        this.mainSwiper.slideToLoop(i);
      }
    },
    colorItemClick(i) {
      this.currentColor = i;
    },
    // ---------- 颜色轮播左右滑动 ----------
    nextColor() {
      const len = this.carDetails.switchColors.length;
      if (!len) return;
      this.currentColor = (this.currentColor + 1) % len;
    },
    prevColor() {
      const len = this.carDetails.switchColors.length;
      if (!len) return;
      this.currentColor = (this.currentColor - 1 + len) % len;
    },
    onColorTouchStart(e) {
      this.colorTouchStartX = e.touches[0].clientX;
      this.colorTouchStartY = e.touches[0].clientY;
    },
    onColorTouchEnd(e) {
      const dx = e.changedTouches[0].clientX - this.colorTouchStartX;
      const dy = e.changedTouches[0].clientY - this.colorTouchStartY;
      // 水平滑动且幅度大于垂直，才判定为左右切换
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) this.nextColor();
        else this.prevColor();
      }
    },
    onColorMouseDown(e) {
      this.colorMouseDown = true;
      this.colorMouseStartX = e.clientX;
    },
    onColorMouseUp(e) {
      if (!this.colorMouseDown) return;
      this.colorMouseDown = false;
      const dx = e.clientX - this.colorMouseStartX;
      if (Math.abs(dx) > 50) {
        if (dx < 0) this.nextColor();
        else this.prevColor();
      }
    },
    onColorMouseLeave() {
      this.colorMouseDown = false;
    },

    lastSwiperItemClick(i) {
      if (this.lastIndex === i) return;
      this.lastIndex = i;
      // 同步大图
      const mainSwiper = this.$refs.lastMainSwiper?.$swiper;
      if (mainSwiper) mainSwiper.slideTo(i);
    },
    onLastMainSlideChange() {
      const mainSwiper = this.$refs.lastMainSwiper?.$swiper;
      if (!mainSwiper) return;
      const idx = mainSwiper.activeIndex;
      if (this.lastIndex === idx) return;
      this.lastIndex = idx;
      // 缩略图滚动到让当前选中项居中可见
      const thumbSwiper = this.$refs.lastPageSwiper?.$swiper;
      if (thumbSwiper) {
        const visibleCount = Math.floor(thumbSwiper.params.slidesPerView);
        const offset = Math.max(0, idx - Math.floor(visibleCount / 2));
        thumbSwiper.slideTo(offset);
      }
    },
    mouseleavelast() {},
    mouseEnterlast() {},
    go360Page() {
      let url_ = "";
      if (this.carType == "V23") {
        url_ = `https://www.icaurglobal.com/global/v23Web3d/`;
      }
      // if (this.isIos) {
      // window.location.href = url_;
      // } else {
      window.open(url_, "_blank");
      // }
    },
    handleMouseEnter(e, i) {
      console.log("e, i :>> ", e, i);

      if (e?.introduce) {
        if (this.columnIndex === i) {
          this.columnIndex = -1;
        } else {
          this.columnIndex = i;
        }
      }
    },
    handleMouse2Enter(e, i) {
      console.log("e, i :>>22 ", e, i);

      if (e?.introduce) {
        if (this.column2Index === i) {
          this.column2Index = -1;
        } else {
          this.column2Index = i;
        }
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.scrollHandler);
    if (this.mainSwiper) this.mainSwiper.destroy(true, true);
    if (this.lastsSwiper) this.lastsSwiper.destroy(true, true);
  },
};
</script>

<style lang="scss" scoped>
// 图片占位图：远程图片加载期间显示占位背景，避免空白/破图造成的显示异常
// 纯图容器（banner / gallery / last-pages 大图）背景下沉到容器：加载失败隐藏 img 后占位仍保留；
// 带文字的容器（内籠外观 / 缩略图）背景加在 img 本身，避免文字区域被染灰；
// 不含透明车图与 logo，以免透明区域永久透出灰底
.banner-top .img-box,
.swiper-box .main-swiper .swiper-slide,
.last-pages .last-main-swiper .swiper-slide,
.car-column .swiper-item_inside .img,
.last-pages .last-page_column .swiper-item_inside .img,
.img-placeholder {
  background-color: #f2f2f2;
}
// el-image 占位/错误插槽样式
.img-placeholder {
  width: 100%;
  height: 100%;
  min-height: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #c0c4cc;
  font-size: 40px;
}
.img-placeholder_error {
  i {
    font-size: 48px;
  }
}
.banner-top {
  width: 100%;
  height: 100vh;
  // padding-top: 60px;
  position: relative;

  .img-box {
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .btn-box {
    width: 100%;
    max-width: 1770px;
    padding: 0 30px;
    // width: 90%;
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translate(-50%, 0%);
    color: #fff;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    .cell-name {
      font-size: 22px;
      font-weight: 600;
    }
    .cell-value {
      padding-top: 10px;
      font-size: 12px;
      color: #ddd;
    }
    .btn-l {
      width: 200px;
      padding-bottom: 30px;
      .cell-value {
        font-size: 14px;
        color: #ddd;
      }
    }
    .btn-r {
      display: flex;
      align-items: center;
      .cell {
        width: 260px;
        // display: flex;
        // flex-direction: column;
        // justify-content: space-around;
        // align-items: center;
      }
      .cell:last-child {
        width: 180px;
      }
    }

    // .btn {
    //   width: 160px;
    //   margin-top: 10px;
    //   line-height: 50px;
    //   font-size: 22px;
    //   text-align: center;
    //   font-weight: 600;
    //   border: #fff solid 1px;
    //   background-color: #fff;
    //   border-radius: 5px;
    //   color: #666;
    //   cursor: pointer;
    // }
  }
}
.text-box {
  position: absolute;
  left: 8%;
  bottom: 10%;
  z-index: 99;
  .title {
    font-size: 30px;
    font-weight: 600;
    text-align: left;
  }
  .introduce {
    font-size: 16px;
    text-align: left;
    white-space: pre-wrap;
  }
}
// -------------------------------------------

.car-column {
  margin-top: 60px;
  .title {
    font-size: 36px;
    font-weight: 600;
    padding-left: 30px;
    line-height: 80px;
  }
  .swiper-column {
    display: flex;
    justify-content: space-between;
    .swiper-item {
      width: 100%;
      padding: 0 20px;
      // padding-bottom: 100%;
      border-radius: 5px;
      overflow: hidden;
      position: relative;
      cursor: pointer;
      .swiper-item_inside {
        width: 100%;
        height: 100%;
        // position: absolute;
        // left: 0;
        // top: 0;
        // background-color: #fafafa;
        .img {
          height: 100%;
          // transition: all 0.6s;
          aspect-ratio: 1 / 1;
        }
        .img:hover {
          // transform: scale3d(1.05, 1.05, 1.05);
        }
      }
      .more-box {
        padding-left: 30px;
        padding-bottom: 20px;
        display: flex;
        justify-content: start;
        align-items: center;
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
        color: #fead80;
        cursor: pointer;
        font-weight: 600;
        z-index: 103;
        display: none;
        .icon {
          font-weight: 600;
          // transition: transform 0.4s;
        }
        .more {
          padding-left: 5px;
        }
        .icon-ac {
          // transform: rotate(180deg);
        }
      }
      .content-box {
        width: 100%;
        // position: absolute;
        // left: 0;
        // top: calc(100% - 90px);
        // transition: top 0.6s ease;
        z-index: 102;

        .swiper-title {
          font-size: 26px;
          font-weight: 600;
          padding-top: 10px;
          padding-bottom: 10px;
          // padding-bottom: 40px;
          text-align: left;
          // color: #fff;
          // transition: padding 0.3s ease;
        }
        .swiper-introduce {
          // padding-top: 10px;
          // color: #ddd;
          // transform-origin: bottom;
          // transition: opacity 0.1s ease;
          // opacity: 0;
          font-size: 14px;
        }
      }
      .content-box_ac {
        .swiper-title {
          padding-bottom: 0px;
        }
        .swiper-introduce {
          opacity: 1;
          transition: opacity 0.55s ease;
        }
        top: calc(100% - 200px);
      }
    }
  }
  .center-indicator {
    // padding-top: 40px;
  }
}
// -------------------------------------------
.swiper-box {
  max-width: 1710px;
  // padding: 60px 0;
  margin: 50px auto;
  height: 100vh;
  position: relative;
  color: #fff;
  cursor: pointer;

  .main-swiper {
    height: 100%;
    .img {
      height: 100%;
    }
    .img-mobile {
      // height: 100vh;
    }
  }
  .text-box {
    bottom: 8%;
  }
  .center-indicator {
    // position: absolute;
    // bottom: 60px;
    // right: 60px;
  }
  .indicator-box {
    position: absolute;
    bottom: 60px;
    right: 60px;
    display: flex;
    justify-content: flex-end;
    z-index: 99;
    // align-items: center;
    .indicator-item {
      width: 16px;
      height: 16px;
      padding: 4px;
      border-radius: 8px;
      background-color: #fff;
      transition: width 0.2s;
      cursor: pointer;
      background-clip: content-box;
    }
    .indicator-item_ac {
      width: 26px;
    }
  }
}
.swiper-box_mobile {
  height: calc(70vh - 40px);
  .center-indicator {
    margin-top: 20px;
  }
}
// -------------------------------------------
.colors-box {
  width: 100%;
  height: 100vh;
  margin: 0 auto;
  position: relative;
  background-image: url("@/assets/img/cartype_bg.jpg");
  background-position: bottom center;
  background-repeat: no-repeat;
  // background-size: 100% 100%;
  background-size: cover;
  overflow: hidden;
  cursor: grab;
  user-select: none;
  -webkit-user-select: none;
  &:active {
    cursor: grabbing;
  }
  // 禁用图片原生拖拽，避免滑动时图片被拖出
  img {
    -webkit-user-drag: none;
    pointer-events: none;
  }

  .color-item {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: flex-end;
    z-index: 98;
    transition: opacity 0.8s;
    opacity: 0;
    .picture,
    .source {
      width: 100%;
    }
    .img {
      height: 100%;
    }
  }
  .current-show {
    opacity: 1;
  }

  .indicator-box {
    position: absolute;
    transform: translate(-50%, 0);
    bottom: 80px;
    // left: 60px;
    left: 50%;
    display: flex;
    justify-content: flex-end;
    z-index: 99;
    .indicator-item {
      .color-text {
        width: 30px;
        margin: 0 6px;
        text-align: center;
        line-height: 60px;
        font-size: 26px;
        opacity: 0;
      }
      .color-text_ac {
        opacity: 1;
      }
    }

    .indicator {
      width: 30px;
      height: 30px;
      margin: 0 8px;
      border-radius: 15px;
      cursor: pointer;
      // border-width: 3px;
      // border-style: solid;
      // border-color: #fafafa;
      background-clip: padding-box;
    }
    .indicator-ac {
      transform: scale(1.15);
      // border-color: transparent;
    }
  }
  .panoramic-360 {
    width: 240px;
    position: absolute;
    top: 100px;
    right: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    line-height: 46px;
    border-radius: 3px;
    .img {
      width: 30px;
      margin-right: 10px;
    }
    .text {
      font-size: 12px;
    }
  }
}
.w-80 {
  .color-item {
    // width: 90%;
    width: 110%;
    max-width: 1300px;
  }
}
.w-fu {
  .color-item {
    width: 100%;
    height: 100%;
  }
  .indicator-box {
    .color-text {
      color: #fff;
    }
  }
}
// -----------------------------
.pages-item {
  // min-height: 80vh;
  position: relative;
  color: #fff;
  .img {
    min-height: 80vh;
    max-height: 100vh;
    // aspect-ratio: 16 / 8;
  }
}
.pages-item1 {
  // background-attachment: fixed;
  // border-color: #1c1c1c;
  // bor
}
// ----------------------------------------------
.last-pages {
  margin-top: 110px;
  padding-top: 100vh;
  position: relative;
  // color: #fff;
  background-color: #f1f1f1;
  .last-main-swiper {
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    .swiper-slide {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
    .img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .text-box_last {
    max-width: 480px;
    padding-bottom: 30px;
    .title {
      font-size: 28px;
      font-weight: 600;
      padding-bottom: 10px;
      text-align: left;
      // color: #fff;
    }
    .introduce {
      max-width: 480px;
      font-weight: 500;
      font-size: 12px;
      // color: #ccc;
    }
  }
  .img {
    // min-height: 80vh;
    // max-height: 100vh;
    // aspect-ratio: 16 / 8;
    height: 100%;
  }
  .late-item {
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    transition: opacity 0.3s ease;
    .text-box {
      color: #f1f1f1;
    }
  }
  .late-item_ac {
    opacity: 1;
  }

  .last-page_column {
    width: 100%;
    position: absolute;
    bottom: 30px;
    left: 0px;
    z-index: 103;
    .swiper-in {
      max-width: 1770px;
      margin: 0 auto;
      padding: 0 20px;
      // display: flex;
      // justify-content: space-between;
      // align-items: flex-end;
    }
    .fsdfsdf {
      width: 100%;
      max-width: 830px;
    }
    .swiper-column {
      // width: 100%;
      margin-left: auto;
      // margin-right: 0;
      // display: flex;
      // justify-content: space-between;
      .swiper-item {
        width: 100%;
        padding-bottom: 86%;
        border-radius: 8px;
        overflow: hidden;
        position: relative;
        cursor: pointer;

        .swiper-item_inside {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          overflow: hidden;
          .img {
            height: 100%;
            transition: all 0.6s;
            z-index: 102;
          }
          .img:hover {
            transform: scale3d(1.05, 1.05, 1.05);
          }
          .content-box {
            width: 100%;
            position: absolute;
            left: 0;
            bottom: 0;
            z-index: 104;
            .swiper-title {
              font-size: 12px;
              font-weight: 600;
              text-align: center;
              color: #fff;
              padding-bottom: 5px;
              -webkit-line-clamp: 2;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
          }
        }
        .swiper-item_inside--ac {
          border: solid #fff 2px;
        }
      }
      .swiper-item::after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 25%;
        background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
      }
    }
  }
}
.last-pages::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 25%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
}
// -----------------------------------
.parameters-box {
  margin-top: 120px;
  padding: 120px 20px;
  background-color: #f7f8f8;
  //background-color: #120f0e;
  .el-table  {
    max-width: 1400px;
    width: 100%;
  }
  .parameters-title {
    font-size: 36px;
    font-weight: 600;
    line-height: 120px;
    color: #000;
    // color: #fff;
  }
  .parameters-img{
    max-width: 1300px;
    display: block;
    margin: 10px 0;
    cursor: pointer;
    margin: 0 auto;
    .sub-title {
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #333;
      padding: 0 0 30px;
    }
    .sub-title:first-child {
      padding-top: 0;
    }
    img {
      width: 100%;
      display: block;
    }
    :deep(.el-image) {
      width: 100%;
      display: block;
    }
  }

  // 分组标题行（合并行）灰色背景
  :deep(.group-title-row) {
    td {
      background-color: #1e1e1e !important;
      border-bottom: 1px solid #333 !important;
    }
  }

  .group-title-cell {
    font-weight: 700;
    font-size: 15px;
    color: #fff;
  }

  // 车型参数列居中（合併后也居中）
  :deep(.el-table__body) td:not(:first-child) {
    text-align: center;
    .cell {
      text-align: center;
    }
  }
  :deep(.el-table) {
    background-color: transparent !important;
  }

  :deep(th) {
    background-color: transparent !important;
    .cell {
      font-weight: 600 !important;
      font-size: 16px;
    }
  }

  // 表头车型列居中
  :deep(th:not(:first-child)) {
    text-align: center;
    .cell {
      text-align: center;
    }
  }

  :deep(tr) {
    background-color: transparent !important;
  }
  :deep(td) {
    border-bottom: 1px solid #222 !important;
  }
  :deep(.is-leaf) {
    border-bottom: 1px solid #222 !important;
  }

  :deep(.el-table__body) tr:hover > td {
    background-color: #000 !important;
    font-size: 16px;
    font-weight: 600 !important;
    color: #f1f1f1;
  }

  :deep(.el-table__body) {
    background-color: transparent !important;
  }

  :deep(.el-table__inner-wrapper::before) {
    display: none;
  }
}
.prop_hint {
  margin-top: 20px;
  padding: 0 10px;
  color: #000;
  // color: #ffffffdc;
  font-size: 14px;
  line-height: 23px;
}
.download-btn-box {
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 0 10px;
  display: flex;
  justify-content: center;
  .btn {
    display: inline-block;
    padding: 2px 50px;
    line-height: 40px;
    border-radius: 20px;
    background-color: #000;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    transition: opacity 0.3s;
    &:hover {
      opacity: 0.8;
    }
  }
}
::v-deep.el-table::before {
  background-color: #222;
  height: 1px;
}
@import "./css/CarDetails-media.scss";
</style>
